export enum GameIds {
  BEAT_THE_STREAK = 'BeatTheStreak2022',
  PICKLE = 'Pickle2023',
  BY_THE_NUMBERS = 'ByTheNumbers2022',
  BINGO = 'Bingo2023',
}
